import React from 'react';
import PropTypes from 'prop-types';

import { PrsButtonLg, PrsButtonStackLg } from '../../../../styles-and-themes/styles/prsButtons';
import { composeDestinationQuerystring } from '../../../../../shared-with-server/destination-utils';
import { destinationInfo } from '../../../../destructured-front-end-config';
import { ForgotPasswordLink } from './LoginForgotControlSetStyles';

const LoginForgotControlSet = ({ onLogin, isFormValid, destPath }) => (
  <PrsButtonStackLg>
    <PrsButtonLg style={{ width: '100%' }} onClick={onLogin} disabled={!isFormValid} id="signin">Sign In</PrsButtonLg>

    <ForgotPasswordLink href={`/uam/forgot-password?${composeDestinationQuerystring(destinationInfo, destPath)}`} title="Forgot your password?" style={{ fontSize: '16px' }}>
      Forgot Password?
    </ForgotPasswordLink>
  </PrsButtonStackLg>
);

LoginForgotControlSet.propTypes = {
  onLogin: PropTypes.func.isRequired,
  isFormValid: PropTypes.bool.isRequired,
  destPath: PropTypes.shape({
    dest: PropTypes.string,
    path: PropTypes.string,
    retURL: PropTypes.string,
  }).isRequired,
};

export default LoginForgotControlSet;
